export default __webpack_public_path__ + "static/media/garden.9b438eeb.svg";